import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {QuestionFlowSessionQuery} from '../../questions/state/question-flow-session.query';
import {environment} from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { API_PATH } from '../../constants';

declare const $: any;
declare function notify(): any;

@Component({
    selector: 'app-question-address',
    templateUrl: './question-address.component.html',
    styleUrls: ['./question-address.component.scss'],
    standalone: false
})
export class QuestionAddressComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild('addressText', {static: false}) addressText: ElementRef;
  @ViewChild('gmap') gmapElement: any;
  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Input() labelText = '';
  @Input() address = '';
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() pressNext = new EventEmitter<any>();

  map: google.maps.Map = null as any;
  marker: google.maps.Marker = null as any;
  notify: any;
  apartmentNo: any;
  complex: any;
  streetAddress: any;
  suburb: any;
  province: any;
  city: any;
  postalCode: any;
  provinces: any = [
    {value: '', label: 'Select Province'},
    {value: 'EC', label: 'Eastern Cape'},
    {value: 'FS', label: 'Free State'},
    {value: 'GP', label: 'Gauteng'},
    {value: 'KZN', label: 'KwaZulu-Natal'},
    {value: 'LP', label: 'Limpopo'},
    {value: 'MP', label: 'Mpumalanga'},
    {value: 'NC', label: 'Northern Cape'},
    {value: 'NW', label: 'North West'},
    {value: 'WC', label: 'Western Cape'}
  ];
  locationForm = new FormGroup({
    apartmentNo: new FormControl(''),
    complex: new FormControl(''),
    streetAddress: new FormControl('', Validators.required),
    suburb: new FormControl('', Validators.required),
    province: new FormControl(''),
    city: new FormControl('', Validators.required),
    postalCode: new FormControl('', Validators.required)
  });
  addresses: any = [];
  showAddresses = false;
  session_details: any;
  url = environment.cssURL;
  // restricts panning/zooming so the map (and therefore the draggable marker) can't leave the allowed country
  mapRestriction: google.maps.MapRestriction = {
    latLngBounds: {north: -22, south: -35, west: 16, east: 33},
    strictBounds: true,
  };
  constructor(
    private ref: ChangeDetectorRef,
     private http: HttpClient,
    private globalQuestionService: GlobalQuestionService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
  ) {
  }

  ngOnInit(): void {
    if (this.url.includes('india')){
      let prov = [];
      this.http.get(API_PATH.INDIA_PROVINCES).subscribe( (result: any) => {
        //console.log(result?.records);
        result?.records.forEach(r => {
          prov.push({value: r.state_code, label: r.state_name_english});
        });
        this.provinces = prov;
      });
    }

  }

  ngAfterViewInit(): void {
    // this.initMap();
   
    this.getPlaceAutocomplete();
    
    if (this.question?.answer) {
      //const answer = this.question.answer.split(',');
      try{
      const address = JSON.parse(this.question.answer);
      this.locationForm.controls.apartmentNo.setValue(address.apartmentNo);
      this.locationForm.controls.complex.setValue(address.complex);
      this.locationForm.controls.streetAddress.setValue(address.streetAddress);
      this.locationForm.controls.suburb.setValue(address.suburb);
      this.locationForm.controls.province.setValue(address.province);
      this.locationForm.controls.city.setValue(address.city);
      this.locationForm.controls.postalCode.setValue(address.postalCode);
      this.province = address.province;
      }
      catch (e) {
        this.parseCommaSeperated(this.question.answer);
      }
     
    } else if (this.address) {
      if (JSON.parse(this.address)){
        const address = JSON.parse(this.address);
        console.log(address);
        this.locationForm.controls.apartmentNo.setValue(address?.apartmentNo);
          this.locationForm.controls.complex.setValue(address?.complex);
          this.locationForm.controls.streetAddress.setValue(address?.streetAddress);
          this.locationForm.controls.suburb.setValue(address?.suburb);
          this.locationForm.controls.province.setValue(address?.province);
          //this.province = answer[4];
          this.locationForm.controls.city.setValue(address?.city);
          this.locationForm.controls.postalCode.setValue(address?.postalCode);
      }
      else{
        const answer = this.address?.split(',');
        if (answer.length < 7) {
          this.locationForm.controls.streetAddress.setValue(answer[0]);
          this.locationForm.controls.suburb.setValue(answer[1]);
          this.locationForm.controls.province.setValue(answer[2]);
          this.province = answer[2];
          this.locationForm.controls.city.setValue(answer[3]);
          this.locationForm.controls.postalCode.setValue(answer[4]);
        } else {
          this.locationForm.controls.apartmentNo.setValue(answer[0]);
          this.locationForm.controls.complex.setValue(answer[1]);
          this.locationForm.controls.streetAddress.setValue(answer[2]);
          this.locationForm.controls.suburb.setValue(answer[3]);
          this.locationForm.controls.province.setValue(answer[4]);
          this.province = answer[4];
          this.locationForm.controls.city.setValue(answer[5]);
          this.locationForm.controls.postalCode.setValue(answer[6]);
        }
      }
      
    } else {
      
      this.globalQuestionService.spinner(true);
      this.session_details = this.questionFlowSessionQuery.getValue();
      if (!this.question?.cent_aq_question_id) { this.globalQuestionService.spinner(false); return; }
      const parameters = new Map<string, string>();
      parameters.set('session_id', this.session_details?.session_id);
      parameters.set('question_id', `${this.question.cent_aq_question_id}`);
      this.globalQuestionService.runCommandNew('getAddress', parameters).subscribe(addresses => {
        if (addresses.length > 0) {
          this.showAddresses = true;
          const add = [];
          let index = 0;
          addresses.forEach(a => {
            if (add.indexOf(a.cent_answer_data) === -1) {
             // add.push(a.cent_answer_data);
              try {
                let json = JSON.parse(a.cent_answer_data.trim());
                let address = '';
                if (json.apartmentNo !== '') address += json.apartmentNo + ', ';
                if (json.complex !== '') address += json.complex + ', ';
                address += json.streetAddress + ', ';
                address += json.suburb + ', ';
                address += json.province + ', ';
                address += json.city + ', ';
                address += json.postalCode;
                add.push({ index: index, address: address, json: a.cent_answer_data });
                index++;
              }
              catch { }
            }
          });
         
          this.addresses = add;

        }
        this.globalQuestionService.spinner(false);
      });
    }
    this.onChanges();
  }
 parseCommaSeperated( text: any): void {
  const answer = text?.split(',');
  if (answer.length < 7) {
    this.locationForm.controls.streetAddress.setValue(answer[0].trim());
    this.locationForm.controls.suburb.setValue(answer[1].trim());
    this.locationForm.controls.province.setValue(answer[3].trim());
    this.province = answer[3].trim();
    this.locationForm.controls.city.setValue(answer[2].trim());
    this.locationForm.controls.postalCode.setValue(answer[4].trim());
  } else {
    this.locationForm.controls.apartmentNo.setValue(answer[0].trim());
    this.locationForm.controls.complex.setValue(answer[1].trim());
    this.locationForm.controls.streetAddress.setValue(answer[2].trim());
    this.locationForm.controls.suburb.setValue(answer[3].trim());
    this.locationForm.controls.province.setValue(answer[4].trim());
    this.province = answer[4].trim();
    this.locationForm.controls.city.setValue(answer[5].trim());
    this.locationForm.controls.postalCode.setValue(answer[6].trim());
  }
 }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.address?.currentValue){
      this.address = changes.address?.currentValue;
      
      if (this.address) {
        let addressObj: any = null;
        try {
          addressObj = JSON.parse(this.address);
        } catch (e) {
          // Not a JSON string, ignore
        }

        if (addressObj && typeof addressObj === 'object') {
          const address = JSON.parse(this.address);
          console.log(address);
          this.locationForm.controls.apartmentNo.setValue(address?.apartmentNo);
          this.locationForm.controls.complex.setValue(address?.complex);
          this.locationForm.controls.streetAddress.setValue(address?.streetAddress);
          this.locationForm.controls.suburb.setValue(address?.suburb);
          this.locationForm.controls.province.setValue(address?.province);
          //this.province = answer[4];
          this.locationForm.controls.city.setValue(address?.city);
          this.locationForm.controls.postalCode.setValue(address?.postalCode);
        }
        else {
          const answer = this.address?.split(',');
          if (answer.length < 7) {
            this.locationForm.controls.streetAddress.setValue(answer[0].trim());
            this.locationForm.controls.suburb.setValue(answer[1].trim());
            this.locationForm.controls.province.setValue(answer[3].trim());
            this.province = answer[3].trim();
            this.locationForm.controls.city.setValue(answer[2].trim());
            this.locationForm.controls.postalCode.setValue(answer[4].trim());
          } else {
            this.locationForm.controls.apartmentNo.setValue(answer[0].trim());
            this.locationForm.controls.complex.setValue(answer[1].trim());
            this.locationForm.controls.streetAddress.setValue(answer[2].trim());  
            this.locationForm.controls.suburb.setValue(answer[3].trim());
            this.locationForm.controls.province.setValue(answer[4].trim());
            this.province = answer[4].trim();
            this.locationForm.controls.city.setValue(answer[5].trim());
            this.locationForm.controls.postalCode.setValue(answer[6].trim());
          }
        }
      }
    }
    
    this.getPlaceAutocomplete();
  }

  initMap(): void {
    const mapCenter = new google.maps.LatLng(-26.1714402, 28.0050051); // jhb
    const mapProp = {
      center: mapCenter,
      zoom: 5,
      mapTypeControl: false,
      streetViewControl: false,

    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, {...mapProp, restriction: this.mapRestriction});
    const markerImage = {
      url: 'assets/3/icn/marker.png',
      size: new google.maps.Size(77, 54),
      scaledSize: new google.maps.Size(77, 54),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(20, 50)
    };

    this.marker = new google.maps.Marker({
      map: this.map,
      draggable: true,
      icon: markerImage
    });

    this.map.setCenter(mapCenter);
    this.marker.setPosition(mapCenter);
    this.marker.setVisible(true);

    // listen for marker drag
    google.maps.event.addListener(this.marker, 'dragend', () => {
      this.getCodePosition(this.marker.getPosition(), false);
    });
  }

  getCountryCode(): string {
    return this.url.includes('india') ? 'IN' : 'ZA';
  }

  getCountryName(): string {
    return this.url.includes('india') ? 'India' : 'South Africa';
  }

  // checks every result (not just the first) because the most specific reverse-geocode
  // result in rural areas is often a plus_code, which has no 'country' component at all
  isAllowedCountry(results: any[]): boolean {
    for (const result of results || []) {
      const country = result?.address_components?.find((c: any) => c.types?.indexOf('country') !== -1);
      if (country) { return country.short_name === this.getCountryCode(); }
    }
    return false;
  }

  getPlaceAutocomplete(): void {
    if (this.addressText) {
      const autocomplete = new google.maps.places.Autocomplete(this.addressText?.nativeElement, {
        componentRestrictions: {country: this.getCountryCode()}
      });

      autocomplete.setFields([
        'address_components',
        'geometry',
        'icon',
        'name',
      ]);

      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        
        if (!place?.address_components) {
          console.warn('No details available for input: \'' + place.name + '\'');
          return;
        } else {
          this.populateAddress(place.address_components);
        }
      });

      google.maps.event.addListener(this.addressText?.nativeElement, 'focus', e => {
        const target = e.target as HTMLInputElement;
        target?.setAttribute('autocomplete', 'new-add');
      });
    }
  }


  getCurrentPosition(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        this.getCodePosition(pos, true);

      }, (error) => {
        if (error.code === 1) {
          this.notify.init({
            message: 'Please enable "location services" for your browser in your Settings in order for us to determine your location.', // required
            icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
            size: 'lg',     // default: null; options: 'lg'
            style: 'info',  // default: null; options: 'info', 'success',
            close: true,    // default: false (close button enabled, auto-close duration removed)
            speed: 350,     // default: 350 (fade in/out speed)
            duration: 5000  // default: 5000 (duration active)
          });
          return;
        } else {
          this.notify.init({
            message: 'We we unable to determine your location automatically. Please drag the marker to indicate your location.', // required
            icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
            size: 'lg',     // default: null; options: 'lg'
            style: 'info',  // default: null; options: 'info', 'success',
            close: true,    // default: false (close button enabled, auto-close duration removed)
            speed: 350,     // default: 350 (fade in/out speed)
            duration: 5000  // default: 5000 (duration active)
          });
          return;
        }
      });
    }
  }

  getCodePosition(pos: any, gotPosition: boolean): void {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({location: pos}, (results, status: string) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (!this.isAllowedCountry(results)) {
          notify()?.init({
            message: '<strong>Please choose a location within ' + this.getCountryName() + '.</strong>',
            icon: 'info',
            size: 'lg',
            style: 'error',
            speed: 350,
            duration: 4000
          });
          return;
        }
        if (gotPosition) {
          this.map.setCenter(pos);
          this.map.setZoom(18);
          this.marker.setPosition(pos);
        }
        this.populateGPSCoords(results[0].geometry.location);
        this.populateAddress(results[0].address_components);
      } else {
        console.warn('error, cannot determine the address at this location');
      }
    });
  }

  populateGPSCoords(location: any): void {
    const gpsInput = $('#address_gps-1');
    gpsInput.val(location.lat() + ', ' + location.lng());
  }

  populateAddress(addressComponents: any): void {
    let addressStreetNumber;
    let addressStreetName;
    this.streetAddress = '';
    this.suburb = '';
    this.city = '';
    this.province = '';
    this.postalCode = '';
    this.locationForm.controls.streetAddress.setValue('');
    this.locationForm.controls.suburb.setValue('');
    this.locationForm.controls.city.setValue('');
    this.locationForm.controls.province.setValue('');
    this.locationForm.controls.postalCode.setValue('');

    for (const item of addressComponents) {
      // street incl. number
      if (item.types.indexOf('street_number') !== -1) {
        addressStreetNumber = item.short_name;
      }

      // Street Name
      if (item.types.indexOf('route') !== -1) {
        addressStreetName = item.long_name;
      }

      // Street Number
      if (addressStreetNumber) {
        // has both name and number
        if (addressStreetName) {
          this.locationForm.controls.streetAddress.setValue(`${addressStreetNumber} ${addressStreetName}`);
          // only number (even possible?)
        } else {
          this.locationForm.controls.streetAddress.setValue(addressStreetNumber);
        }
        // only name
      } else if (addressStreetName) {
        this.locationForm.controls.streetAddress.setValue(addressStreetName);
      }


      // suburb
      if ((item.types.indexOf('sublocality') !== -1
          || item.types.indexOf('sublocality_level_1') !== -1
          || item.types.indexOf('sublocality_level_2') !== -1)
        && item.types.indexOf('political') !== -1) {
        if (!this.suburb) {
          this.suburb = item.short_name;
          this.locationForm.controls.suburb.setValue(this.suburb);
        }
      }

      // city
      if (item.types.indexOf('locality') !== -1 && item.types.indexOf('political') !== -1) {
        this.city = item.short_name;
        this.locationForm.controls.city.setValue(this.city);
      }

      // province
      if (item.types.indexOf('administrative_area_level_1') !== -1 && item.types.indexOf('political') !== -1) {
        this.province = item.short_name;
        this.locationForm.controls.province.setValue(this.province);
      }

      // postal code
      if (item.types.indexOf('postal_code') !== -1) {
        this.postalCode = item.short_name;
        this.locationForm.controls.postalCode.setValue(this.postalCode);
      }
      this.ref.detectChanges();
    }
    let required = $('.required');
    $(required).each((i,e) =>{
      if (e.value === '' || undefined){
        $(e).addClass('has-error');
      }
      else{
        $(e).removeClass('has-error');
      }
    })
    //setTimeout(() => {
      this.checkText(null);
    //}, 1000);
    
  }

  combinedAddress(): any {
    this.apartmentNo = this.locationForm.get('apartmentNo')?.value;
    this.complex = this.locationForm.get('complex')?.value;
    this.streetAddress = this.locationForm.get('streetAddress')?.value;
    this.suburb = this.locationForm.get('suburb')?.value;
    this.province = this.locationForm.get('province')?.value;
    this.city = this.locationForm.get('city')?.value;
    this.postalCode = this.locationForm.get('postalCode')?.value;

    // let address = '';
    // if (this.apartmentNo !== '') {
    //   address += this.apartmentNo + ',';
    // }
    // if (this.complex !== '') {
    //   address += this.complex + ',';
    // }
    // address +=
    //   this.streetAddress + ', '
    //   + this.suburb + ', '
    //   + this.province + ', '
    //   + this.city + ', '
    //   + this.postalCode;
    // return address;


    const address = {
      apartmentNo: this.apartmentNo.trim(),
      complex: this.complex.trim(),
      streetAddress: this.streetAddress.trim(),
      suburb: this.suburb.trim(),
      province: this.province.trim(),
      city: this.city.trim(),
      postalCode: this.postalCode.trim()
    };
    

    return JSON.stringify(address);
  }

  changeProvince(event: any): void {
    this.province = event;
    this.locationForm.get('province').setValue(this.province);
  }


  onChanges(): void {
    this.locationForm.valueChanges.subscribe(() => {
      if (this.locationForm.valid) {
        //this.submitResponse();
      }
    });
  }

  setAddress(event): void {
    if (event === 'new') {
      this.showAddresses = false;
      this.ref.detectChanges();
      this.getPlaceAutocomplete();
      return;
    }
    this.question.answer = this.addresses[event.index]?.json;
    //const answer = this.question.answer.split(',');
    //const answer = JSON.parse(this.question.answer);
    // if (answer.length < 7) {
    //   this.locationForm.controls.streetAddress.setValue(answer[0]);
    //   this.locationForm.controls.suburb.setValue(answer[1]);
    //   this.locationForm.controls.province.setValue(answer[2]);
    //   this.locationForm.controls.city.setValue(answer[3]);
    //   this.locationForm.controls.postalCode.setValue(answer[4]);
    // } else {
    //   this.locationForm.controls.apartmentNo.setValue(answer[0]);
    //   this.locationForm.controls.complex.setValue(answer[1]);
    //   this.locationForm.controls.streetAddress.setValue(answer[2]);
    //   this.locationForm.controls.suburb.setValue(answer[3]);
    //   this.locationForm.controls.province.setValue(answer[4]);
    //   this.locationForm.controls.city.setValue(answer[5]);
    //   this.locationForm.controls.postalCode.setValue(answer[6]);
    // }
    
    if (this.showAddresses){
      this.questionAnswer.emit(this.question);
    }
    else{
      this.submitResponse();
    }
    
    /*this.showAddresses = false;*/
  }
 checkText(event) : void {
  let er = false;
  let required = $('.required');
  $(required).each((i,e) =>{
    if (e.value === '' || undefined){
      $(e).addClass('has-error');
      er = true;
    }
    else{
      $(e).removeClass('has-error');
    }
  })

  if (!er && this.locationForm.valid){
    this.submitResponse();
  }
 }
  submitResponse(): void {
    if (this.question) {
      this.question.answer = this.combinedAddress();
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(this.combinedAddress());
    }
  }

}
